import React, { useState, useRef, useEffect } from 'react'
import { adBpCondition } from '../../utils/js/ad_helpers'
import { sn_url } from '../../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'
import useAds from '../../context/AdsContext'

function Leaderboard(props) {
    //custom hooks
    const { ads, adblockIsDetected, selectedLeaderboardBanner } = useAds()
    // used to check cycles
    const mounted = useRef()

    let getStateObj = (bp_condition, props) => {
        if (bp_condition && props.visible && !props.unMounting && props.index) {
            let adType = props.refresh ? '_AD_LEADERBOARD' : '_AD_NOAR_LEADERBOARD'
            let adId = ads !== {} ? 'leaderboard_' + props.index + '_' + ads : 'leaderboard_01'
            adId = props.plusOneIterator ? 'leaderboard_' + props.index + '_' + (+ads + 1) : adId
            return { render: true, adArg: { type: adType, id: adId, container: 'ad-container-lb' } }
        } else if (bp_condition) {
            let adType = props.refresh ? '_AD_LEADERBOARD' : '_AD_NOAR_LEADERBOARD'
            let adId = ads !== {} ? 'leaderboard_0' + ads : 'leaderboard_01'
            adId = props.plusOneIterator ? 'leaderboard_0' + (+ads + 1) : adId
            return { render: true, adArg: { type: adType, id: adId, container: 'ad-container-lb' } }
        } else {
            return { render: false, adArg: {} }
        }
    }
    let performAdUpdate = () => {
        try {
            window.adUtility.insertAd(state.adArg.id, {
                type: window.adUtility[state.adArg.type],
                adPath: window.adUnitPath,
                targeting: window.adTargets(),
            })
        } catch (e) {
            handleError(e)
        }
    }
    let bp_condition = adBpCondition(props.view)
    let stateObj = getStateObj(bp_condition, props)
    const [state, setState] = useState(stateObj)

    useEffect(() => {
        if (!mounted.current) {
            // componentDidMount logic
            const setAd = async () => {
                const setAdTargetSuccess = await setAdTargets()
                if (setAdTargetSuccess) {
                    performAdUpdate()
                }
            }
            setAd().catch(err => {
                handleError(err)
            })
            mounted.current = true
        } else {
            //  componentDidUpdate logic
            if (props.visible && !props.unMounting && state.render) {
                performAdUpdate()
            }
        }
    })

    useEffect(() => {
        //component will update
        let nextProps = props
        let bp_condition = adBpCondition(nextProps.view)

        if (bp_condition && !nextProps.unMounting && nextProps.visible) {
            let stateObj = getStateObj(bp_condition, nextProps)
            setState(stateObj)
        } else if (!nextProps.visible) {
            setState({ render: false })
        }
    }, [props])

    let setAdTargets = () => {
        let currentURL = sn_url.replace('https://', '')
        currentURL = currentURL + window.location.pathname

        let endpoint = sn_url + '/wp-json/rsm-adutil/v1/get_ad_targets_by_url/' + currentURL

        return fetch(endpoint)
            .then(response => response.json())
            .then(res => {
                window.adTargets = function() {
                    return res
                }

                if (res.ad_unit_path) {
                    window.adUnitPath = res.ad_unit_path
                } else {
                    window.adUnitPath = '/7326/en.sportsnet.web/' + res.section
                }

                return true
            })
            .catch(err => {
                handleError(err)
                return false
            })
    }

    return (
        <div>
            {state.render && (
                <div style={{ backgroundColor: props.bg ? 'white' : 'transparent' }}>
                    {adblockIsDetected && (
                        <div id={state.adArg.id} className={`${state.adArg.container}`}>
                            <img
                                style={{ height: 90, width: 728 }}
                                src={selectedLeaderboardBanner}
                                alt="Support Sportsnet by disabling your adblocker"
                            />
                        </div>
                    )}
                    {!adblockIsDetected && (
                        <div id={state.adArg.id} className={`${state.adArg.container}`} />
                    )}
                </div>
            )}
        </div>
    )
}

export default Leaderboard
